<template>
  <div>
    <v-btn
        v-if="
          operationGroup.reverseBy===null &&// еще не возвращена
          operationGroup.operationGroupType.reverseBys.length>0 && // может быть возвращена
          operationGroup.fixedBy===null // еще не сторнирована
        "
        @click="reverseByOpen=true"
        color="error" depressed small class="mr-2"
    >
      <v-icon small class="mr-2">mdi-arrow-u-down-right</v-icon>Возврат
    </v-btn>
    <btn-small-accept
        v-if="
          operationGroup.fixedBy===null // еще не сторнирована
        "
        color="error"
        btnClass="mr-2"
        name="Сторнировать"
        icon="mdi-arrow-u-down-right"
        text="Операция будет полностью сторнирована. Вы уверены?"
        @accept="fixedByAction();"
        :loading="fixedByState.isLoading"
    />

    <dialog-view
        :open="reverseByOpen"
        @cancel="reverseByOpen=false"
        title="Выберите способ возврата"
    >
      <template v-slot:content>
        <radios
            name="Хоз.операция"
            :items="operationGroup.operationGroupType.reverseBys"
            @update:select="(v)=>reverseByOpen=v"
        />
      </template>
      <template v-slot:actions>
        <v-btn text color="primary" @click="$store.commit('alertWarning', 'В данный момент операция не поддерживается')">ОК</v-btn>
      </template>
    </dialog-view>
  </div>
</template>

<script>
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";
import DialogView from "@/components/DialogView.vue";
import Radios from "@/componentsV2/base/Radios.vue";
import State from "../../plugins/state";
import axios from "axios";
import Api from "../../Api";

export default {
  components: {Radios, DialogView, BtnSmallAccept},
  props:['operationGroup'],
  data: () => ({
    reverseByOpen: false,
    reverseBy:null,
    fixedByState:new State()
  }),
  methods:{
    fixedByAction(){
      this.fixedByState.stateLoading();
      axios.put(Api.host+'/finance/operationGroup/'+this.operationGroup.id+'/fixed/').then(()=>{
        this.fixedByState.stateSuccess();
        this.$emit('fixed');
      }).catch(()=>{
        this.fixedByState.stateError();
      })
    }
  }
}
</script>